import Vue from 'vue';
import { Component, Watch, Prop } from 'vue-property-decorator';
import { RestaurantAddress } from '@/models';
import { ui } from '@/constants';

const DARK_BROWN = '#ebe6e2';

const STYLES: google.maps.MapTypeStyle[] = [
  { stylers: [{ visibility: 'off' }] },
  { featureType: 'landscape', stylers: [{ visibility: 'on' }] },
  { featureType: 'landscape.man_made', stylers: [{ color: ui.colors.greyMedium }] },
  { featureType: 'landscape.natural', elementType: 'geometry.fill', stylers: [{ color: DARK_BROWN }] },
  { featureType: 'road.arterial', stylers: [{ visibility: 'on' }] },
  { featureType: 'road.arterial', elementType: 'geometry.stroke', stylers: [{ color: DARK_BROWN }] },
  { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: DARK_BROWN }, { visibility: 'on' }] },
  { featureType: 'road.local', stylers: [{ visibility: 'on' }] },
  { featureType: 'road.local', elementType: 'geometry.stroke', stylers: [{ color: DARK_BROWN }] },
];

@Component({
  name: 'CmgOrderConfirmationHeaderMap',
})
export default class CmgOrderConfirmationHeaderMap extends Vue {
  map: google.maps.Map | null = null;

  @Prop({ required: true, type: Object })
  address!: RestaurantAddress;

  @Watch('address', { deep: true, immediate: true })
  onAddressChanged(address: RestaurantAddress) {
    this.initMap(address);
  }

  async initMap(address: RestaurantAddress) {
    const google = await this.$services.googleMaps.getGoogleMaps();

    if (!this.map) {
      this.map = new google.maps.Map(this.$refs['map'] as HTMLElement, {
        styles: STYLES,
        zoom: 15,
        draggable: false,
        disableDefaultUI: true,
        draggableCursor: 'normal'
      });
    }

    this.map.setCenter({
      lat: address.latitude || 0,
      lng: address.longitude || 0,
    });
  }
}
